<div id="wrapper" class="center">
    <svg class="progress" x="0px" y="0px" viewBox="-200 -125 776 628">
      <path
        class="track"
        id="trackPath"
        d="M190.233 2.58256L368.428 104.746C370.449 105.904 371.695 108.056 371.695 110.385V314.615C371.695 316.944 370.449 319.095 368.428 320.254L190.233 422.417C188.231 423.565 185.769 423.565 183.767 422.417L5.57159 320.254C3.55088 319.095 2.30453 316.944 2.30453 314.615V110.385C2.30453 108.056 3.55087 105.905 5.57159 104.746L183.767 2.58256C185.769 1.43453 188.231 1.43453 190.233 2.58256Z"
        [attr.stroke]="color"
        [attr.stroke-dasharray]="(progress * 1300) / 100 + ' ' + ((100 - progress) * 1300) / 100"
        stroke-dashoffset="30"
      ></path>
    </svg>
  </div> 


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/achievement/components/progressBar/progress-bar.component.ts.AchivementProgressComponent.html